export default __webpack_public_path__ + "static/media/avatar.358b06fe.png";